// The order of groups and fields inside groups is IMPORTANT. It will do the sorting of columns following the sequence from here.
// However, on UI they will be sorted alphabetically
export const fixturePlayByPlayFlaggedEventsExportFields = [
  {
    titleIntlKey: "fixturePBPEvent.export.columns.fixture.title",
    fields: ["fixtureId", "fixtureStartTimeLocal", "fixtureHomeNames", "fixtureAwayNames"],
  },
  {
    titleIntlKey: "fixturePBPEvent.export.columns.entity.title",
    fields: ["entityId", "entityName"],
  },
  {
    titleIntlKey: "fixturePBPEvent.export.columns.person.title",
    fields: ["personId", "personName"],
  },
  {
    titleIntlKey: "fixturePBPEvent.export.columns.event.title",
    fields: [
      "eventId",
      "eventType",
      "subType",
      "periodId",
      "clock",
      "eventTime",
      "status",
      "class",
      "flagged",
      "highlight",
      "success",
      "officialId",
      "playId",
      "received",
      "topic",
      "type",
      "clientId",
      "shotClock",
      "section",
      "sequence",
      "zone",
    ],
  },
];

export const defaultFixturePlayByPlayFlaggedEventsExportFieldNames = [
  "fixtureStartTimeLocal",
  "fixtureHomeNames",
  "fixtureAwayNames",
  "fixtureId",
  "periodId",
  "clock",
  "entityId",
  "entityName",
  "personId",
  "personName",
  "eventId",
  "eventType",
  "subType",
];
